import * as wasm from './sandtable_bg.wasm';

const lTextDecoder = typeof TextDecoder === 'undefined' ? (0, module.require)('util').TextDecoder : TextDecoder;

let cachedTextDecoder = new lTextDecoder('utf-8', { ignoreBOM: true, fatal: true });

cachedTextDecoder.decode();

let cachegetUint8Memory0 = null;
function getUint8Memory0() {
    if (cachegetUint8Memory0 === null || cachegetUint8Memory0.buffer !== wasm.memory.buffer) {
        cachegetUint8Memory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachegetUint8Memory0;
}

function getStringFromWasm0(ptr, len) {
    return cachedTextDecoder.decode(getUint8Memory0().subarray(ptr, ptr + len));
}

function notDefined(what) { return () => { throw new Error(`${what} is not defined`); }; }
/**
*/
export const Species = Object.freeze({ Empty:0,"0":"Empty",Wall:1,"1":"Wall",Sand:2,"2":"Sand",Water:3,"3":"Water",Stone:13,"13":"Stone",Ice:9,"9":"Ice",Gas:4,"4":"Gas",Cloner:5,"5":"Cloner",Mite:15,"15":"Mite",Wood:7,"7":"Wood",Plant:11,"11":"Plant",Fungus:18,"18":"Fungus",Seed:19,"19":"Seed",Fire:6,"6":"Fire",Lava:8,"8":"Lava",Acid:12,"12":"Acid",Dust:14,"14":"Dust",Oil:16,"16":"Oil",Rocket:17,"17":"Rocket", });
/**
*/
export class Cell {

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cell_free(ptr);
    }
}
/**
*/
export class Universe {

    static __wrap(ptr) {
        const obj = Object.create(Universe.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_universe_free(ptr);
    }
    /**
    */
    reset() {
        wasm.universe_reset(this.ptr);
    }
    /**
    */
    tick() {
        wasm.universe_tick(this.ptr);
    }
    /**
    * @returns {number}
    */
    width() {
        var ret = wasm.universe_width(this.ptr);
        return ret;
    }
    /**
    * @returns {number}
    */
    height() {
        var ret = wasm.universe_height(this.ptr);
        return ret;
    }
    /**
    * @returns {number}
    */
    cells() {
        var ret = wasm.universe_cells(this.ptr);
        return ret;
    }
    /**
    * @returns {number}
    */
    winds() {
        var ret = wasm.universe_winds(this.ptr);
        return ret;
    }
    /**
    * @returns {number}
    */
    burns() {
        var ret = wasm.universe_burns(this.ptr);
        return ret;
    }
    /**
    * @param {number} x
    * @param {number} y
    * @param {number} size
    * @param {number} species
    */
    paint(x, y, size, species) {
        wasm.universe_paint(this.ptr, x, y, size, species);
    }
    /**
    */
    push_undo() {
        wasm.universe_push_undo(this.ptr);
    }
    /**
    */
    pop_undo() {
        wasm.universe_pop_undo(this.ptr);
    }
    /**
    */
    flush_undos() {
        wasm.universe_flush_undos(this.ptr);
    }
    /**
    * @param {number} width
    * @param {number} height
    * @returns {Universe}
    */
    static new(width, height) {
        var ret = wasm.universe_new(width, height);
        return Universe.__wrap(ret);
    }
}
/**
*/
export class Wind {

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_wind_free(ptr);
    }
}

export const __wbg_random_69f01e50b30c8d0a = typeof Math.random == 'function' ? Math.random : notDefined('Math.random');

export const __wbindgen_throw = function(arg0, arg1) {
    throw new Error(getStringFromWasm0(arg0, arg1));
};

